import { useTableStore } from "@/components/organisms/Table/Table.store";
import { Skeleton } from "@/components/ui/skeleton";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/components/ui/utils";
import { Checkbox } from "@/components/ui/checkbox";

/** As a row shows its number, the header shows how many rows there are - and,
 * as a row does, the checkbox in its place on hover or once every row is checked. */
export function TableHeaderCheckbox({
  totalCount,
  isLoading,
}: {
  totalCount: number;
  isLoading: boolean;
}) {
  const isAllRowsChecked = useTableStore((store) => store.isAllRowsChecked);
  const checkedRows = useTableStore((store) => store.checkedRows);
  const setCheckedRows = useTableStore((store) => store.setCheckedRows);
  const setIsAllRowsChecked = useTableStore(
    (store) => store.setIsAllRowsChecked,
  );

  return (
    <div
      data-testid="table-header-checkbox"
      className={cn(
        "w-full h-full flex items-center justify-center",
        isAllRowsChecked
          ? "[&_>_.TableHeaderCheckbox-check]:flex"
          : "[&_>_.TableHeaderCheckbox-check]:hidden",
        isAllRowsChecked
          ? "[&_>_.TableHeaderCheckbox-count]:hidden"
          : "[&_>_.TableHeaderCheckbox-count]:flex",
        !isLoading &&
          "[&:hover_>_.TableHeaderCheckbox-check]:flex [&:hover_>_.TableHeaderCheckbox-count]:hidden",
      )}
    >
      <Checkbox
        checked={isAllRowsChecked}
        className="TableHeaderCheckbox-check"
        data-testid="table-header-checkbox-check"
        disabled={Object.keys(checkedRows || {}).length === 0}
        onCheckedChange={() => {
          setIsAllRowsChecked(!isAllRowsChecked);
          setCheckedRows(
            Object.fromEntries(
              Object.keys(checkedRows).map((key) => [key, !isAllRowsChecked]),
            ),
          );
        }}
      />
      <Typography
        className="TableHeaderCheckbox-count text-muted-foreground/80"
        level="body-xs"
      >
        <Skeleton loading={isLoading} variant="inline">
          {totalCount}
        </Skeleton>
      </Typography>
    </div>
  );
}
